import { useState } from 'react';
import Layout from '../../../../components/layout/Layout';
import { useNavigate, useParams } from 'react-router-dom';

export default function DetalheVendaPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [visualizacao, setVisualizacao] = useState<'xml' | 'pdf' | 'imagem'>('pdf');
  const [zoom, setZoom] = useState(100);
  const [rotacao, setRotacao] = useState(0);
  const [motivo, setMotivo] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [acaoSelecionada, setAcaoSelecionada] = useState<'aprovar' | 'reprovar' | 'solicitar' | 'escalar' | null>(null);

  const venda = {
    id: id || 'VND-2024-001',
    campanha: 'Black Friday 2024',
    participante: 'João Silva',
    pdv: 'Supermercado Central',
    cnpj: '12.345.678/0001-90',
    produto: 'Smartphone Galaxy S23',
    sku: 'SM-S911B',
    valor: 'R$ 3.499,00',
    status: 'em_auditoria',
    origem: 'integracao',
    risco: 'medio',
    data: '15/12/2024',
    hora: '14:35:22'
  };

  const dadosExtraidos = {
    cnpjEmissor: '12.345.678/0001-90',
    razaoSocial: 'Supermercado Central Ltda',
    dataVenda: '15/12/2024',
    horaVenda: '14:35:22',
    numeroNF: '000.123.456',
    serie: '001',
    produtos: [
      { nome: 'Smartphone Galaxy S23', quantidade: 1, valorUnitario: 'R$ 3.499,00', valorTotal: 'R$ 3.499,00' }
    ],
    subtotal: 'R$ 3.499,00',
    desconto: 'R$ 0,00',
    valorTotal: 'R$ 3.499,00'
  };

  const regrasAplicadas = [
    { regra: 'Produto elegível', status: 'aprovado', descricao: 'Produto está na lista de elegíveis da campanha' },
    { regra: 'Limite de valor', status: 'aprovado', descricao: 'Valor dentro do limite permitido (até R$ 5.000)' },
    { regra: 'Período válido', status: 'aprovado', descricao: 'Venda realizada dentro do período da campanha' },
    { regra: 'PDV permitido', status: 'aprovado', descricao: 'PDV está cadastrado e ativo na campanha' },
    { regra: 'Duplicidade', status: 'alerta', descricao: 'Nota fiscal não encontrada em vendas anteriores' },
    { regra: 'Valor fora de faixa', status: 'aprovado', descricao: 'Valor está dentro da faixa esperada para o produto' }
  ];

  const historicoAuditoria = [
    { data: '15/12/2024 14:36:00', usuario: 'Sistema', acao: 'Venda recebida via integração sistêmica', tipo: 'info' },
    { data: '15/12/2024 14:36:05', usuario: 'Sistema', acao: 'Dados extraídos automaticamente do XML', tipo: 'info' },
    { data: '15/12/2024 14:36:10', usuario: 'Sistema', acao: 'Regras de auditoria aplicadas', tipo: 'info' },
    { data: '15/12/2024 14:36:15', usuario: 'Sistema', acao: 'Venda encaminhada para auditoria manual (risco médio)', tipo: 'warning' }
  ];

  const handleAcao = (acao: 'aprovar' | 'reprovar' | 'solicitar' | 'escalar') => {
    setAcaoSelecionada(acao);
    setShowModal(true);
  };

  const confirmarAcao = () => {
    console.log(`Ação: ${acaoSelecionada}, Motivo: ${motivo}`);
    setShowModal(false);
    setMotivo('');
    navigate('/admin/auditoria/vendas');
  };

  const getStatusIcon = (status: string) => {
    if (status === 'aprovado') return { icon: 'ri-checkbox-circle-fill', color: 'text-emerald-600' };
    if (status === 'alerta') return { icon: 'ri-alert-fill', color: 'text-amber-600' };
    return { icon: 'ri-close-circle-fill', color: 'text-red-600' };
  };

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <button
              onClick={() => navigate('/admin/auditoria/vendas')}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-left-line text-gray-600"></i>
              </div>
            </button>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Auditoria de Venda - {venda.id}</h1>
              <p className="text-sm text-gray-600 mt-1">Revise os documentos e dados extraídos</p>
            </div>
          </div>
        </div>

        {/* Layout em Duas Colunas */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Coluna Esquerda - Documento Fiscal */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Documento Fiscal</h3>
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => setVisualizacao('xml')}
                  className={`px-3 py-1 rounded-lg text-sm cursor-pointer whitespace-nowrap ${visualizacao === 'xml' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
                >
                  XML
                </button>
                <button
                  onClick={() => setVisualizacao('pdf')}
                  className={`px-3 py-1 rounded-lg text-sm cursor-pointer whitespace-nowrap ${visualizacao === 'pdf' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
                >
                  PDF
                </button>
                <button
                  onClick={() => setVisualizacao('imagem')}
                  className={`px-3 py-1 rounded-lg text-sm cursor-pointer whitespace-nowrap ${visualizacao === 'imagem' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
                >
                  Imagem
                </button>
              </div>
            </div>

            {/* Controles de Visualização */}
            <div className="flex items-center justify-between mb-4 p-3 bg-gray-50 rounded-lg">
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => setZoom(Math.max(50, zoom - 10))}
                  className="p-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 cursor-pointer"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-zoom-out-line text-gray-600"></i>
                  </div>
                </button>
                <span className="text-sm font-medium text-gray-700">{zoom}%</span>
                <button
                  onClick={() => setZoom(Math.min(200, zoom + 10))}
                  className="p-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 cursor-pointer"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-zoom-in-line text-gray-600"></i>
                  </div>
                </button>
              </div>
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => setRotacao((rotacao - 90) % 360)}
                  className="p-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 cursor-pointer"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-anticlockwise-line text-gray-600"></i>
                  </div>
                </button>
                <button
                  onClick={() => setRotacao((rotacao + 90) % 360)}
                  className="p-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 cursor-pointer"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-clockwise-line text-gray-600"></i>
                  </div>
                </button>
                <button className="p-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 cursor-pointer">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-download-line text-gray-600"></i>
                  </div>
                </button>
              </div>
            </div>

            {/* Área de Visualização */}
            <div className="border-2 border-gray-200 rounded-lg p-4 bg-gray-50 min-h-[600px] flex items-center justify-center overflow-auto">
              {visualizacao === 'xml' && (
                <div className="w-full h-full bg-white p-4 rounded font-mono text-xs overflow-auto">
                  <pre className="text-gray-700">
{`<?xml version="1.0" encoding="UTF-8"?>
<nfeProc versao="4.00">
  <NFe>
    <infNFe Id="NFe12345678901234567890123456789012345678901234">
      <ide>
        <cUF>35</cUF>
        <natOp>VENDA</natOp>
        <mod>55</mod>
        <serie>001</serie>
        <nNF>123456</nNF>
        <dhEmi>2024-12-15T14:35:22-03:00</dhEmi>
      </ide>
      <emit>
        <CNPJ>12345678000190</CNPJ>
        <xNome>Supermercado Central Ltda</xNome>
      </emit>
      <det nItem="1">
        <prod>
          <cProd>SM-S911B</cProd>
          <xProd>Smartphone Galaxy S23</xProd>
          <qCom>1.0000</qCom>
          <vUnCom>3499.00</vUnCom>
          <vProd>3499.00</vProd>
        </prod>
      </det>
      <total>
        <ICMSTot>
          <vNF>3499.00</vNF>
        </ICMSTot>
      </total>
    </infNFe>
  </NFe>
</nfeProc>`}
                  </pre>
                </div>
              )}
              {visualizacao === 'pdf' && (
                <div
                  className="bg-white shadow-lg"
                  style={{
                    transform: `scale(${zoom / 100}) rotate(${rotacao}deg)`,
                    transition: 'transform 0.3s ease'
                  }}
                >
                  <img
                    src="https://readdy.ai/api/search-image?query=professional%20brazilian%20tax%20invoice%20nota%20fiscal%20eletronica%20NFe%20document%20with%20company%20header%20product%20details%20barcode%20and%20official%20government%20seal%20clean%20white%20background%20high%20quality%20business%20document&width=600&height=800&seq=nfe-doc-001&orientation=portrait"
                    alt="Nota Fiscal"
                    className="w-full h-auto"
                  />
                </div>
              )}
              {visualizacao === 'imagem' && (
                <div
                  className="bg-white shadow-lg"
                  style={{
                    transform: `scale(${zoom / 100}) rotate(${rotacao}deg)`,
                    transition: 'transform 0.3s ease'
                  }}
                >
                  <img
                    src="https://readdy.ai/api/search-image?query=scanned%20receipt%20cupom%20fiscal%20brasileiro%20thermal%20paper%20receipt%20from%20supermarket%20with%20product%20list%20prices%20barcode%20store%20logo%20clear%20text%20realistic%20photo&width=400&height=600&seq=cupom-scan-001&orientation=portrait"
                    alt="Cupom Fiscal"
                    className="w-full h-auto"
                  />
                </div>
              )}
            </div>
          </div>

          {/* Coluna Direita - Dados Extraídos */}
          <div className="space-y-6">
            {/* Dados Extraídos */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Dados Extraídos</h3>
              <div className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="text-xs font-medium text-gray-500 uppercase">CNPJ Emissor</label>
                    <p className="text-sm font-semibold text-gray-900 mt-1">{dadosExtraidos.cnpjEmissor}</p>
                  </div>
                  <div>
                    <label className="text-xs font-medium text-gray-500 uppercase">Razão Social</label>
                    <p className="text-sm font-semibold text-gray-900 mt-1">{dadosExtraidos.razaoSocial}</p>
                  </div>
                  <div>
                    <label className="text-xs font-medium text-gray-500 uppercase">Data da Venda</label>
                    <p className="text-sm font-semibold text-gray-900 mt-1">{dadosExtraidos.dataVenda}</p>
                  </div>
                  <div>
                    <label className="text-xs font-medium text-gray-500 uppercase">Hora da Venda</label>
                    <p className="text-sm font-semibold text-gray-900 mt-1">{dadosExtraidos.horaVenda}</p>
                  </div>
                  <div>
                    <label className="text-xs font-medium text-gray-500 uppercase">Número NF</label>
                    <p className="text-sm font-semibold text-gray-900 mt-1">{dadosExtraidos.numeroNF}</p>
                  </div>
                  <div>
                    <label className="text-xs font-medium text-gray-500 uppercase">Série</label>
                    <p className="text-sm font-semibold text-gray-900 mt-1">{dadosExtraidos.serie}</p>
                  </div>
                </div>

                <div className="border-t border-gray-200 pt-4">
                  <label className="text-xs font-medium text-gray-500 uppercase mb-3 block">Produtos</label>
                  <div className="space-y-2">
                    {dadosExtraidos.produtos.map((produto, index) => (
                      <div key={index} className="bg-gray-50 rounded-lg p-3">
                        <div className="flex items-center justify-between mb-2">
                          <p className="text-sm font-semibold text-gray-900">{produto.nome}</p>
                          <p className="text-sm font-bold text-gray-900">{produto.valorTotal}</p>
                        </div>
                        <div className="flex items-center justify-between text-xs text-gray-600">
                          <span>Qtd: {produto.quantidade}</span>
                          <span>Unit: {produto.valorUnitario}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="border-t border-gray-200 pt-4">
                  <div className="space-y-2">
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-gray-600">Subtotal</span>
                      <span className="font-semibold text-gray-900">{dadosExtraidos.subtotal}</span>
                    </div>
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-gray-600">Desconto</span>
                      <span className="font-semibold text-gray-900">{dadosExtraidos.desconto}</span>
                    </div>
                    <div className="flex items-center justify-between text-lg border-t border-gray-200 pt-2">
                      <span className="font-bold text-gray-900">Valor Total</span>
                      <span className="font-bold text-blue-600">{dadosExtraidos.valorTotal}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Regras Aplicadas */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Regras Aplicadas Automaticamente</h3>
              <div className="space-y-3">
                {regrasAplicadas.map((regra, index) => {
                  const statusIcon = getStatusIcon(regra.status);
                  return (
                    <div key={index} className="flex items-start space-x-3 p-3 bg-gray-50 rounded-lg">
                      <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 ${statusIcon.color}`}>
                        <i className={statusIcon.icon}></i>
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-semibold text-gray-900">{regra.regra}</p>
                        <p className="text-xs text-gray-600 mt-1">{regra.descricao}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Ações do Auditor */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Ações do Auditor</h3>
              <div className="grid grid-cols-2 gap-3">
                <button
                  onClick={() => handleAcao('aprovar')}
                  className="px-4 py-3 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center space-x-2"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-checkbox-circle-line"></i>
                  </div>
                  <span className="font-semibold">Aprovar Venda</span>
                </button>
                <button
                  onClick={() => handleAcao('reprovar')}
                  className="px-4 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center space-x-2"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-close-circle-line"></i>
                  </div>
                  <span className="font-semibold">Reprovar Venda</span>
                </button>
                <button
                  onClick={() => handleAcao('solicitar')}
                  className="px-4 py-3 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center space-x-2"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-file-add-line"></i>
                  </div>
                  <span className="font-semibold">Solicitar Complemento</span>
                </button>
                <button
                  onClick={() => handleAcao('escalar')}
                  className="px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center space-x-2"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-user-star-line"></i>
                  </div>
                  <span className="font-semibold">Escalar p/ Supervisor</span>
                </button>
              </div>
            </div>

            {/* Histórico de Auditoria */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Histórico de Auditoria</h3>
              <div className="space-y-3">
                {historicoAuditoria.map((item, index) => (
                  <div key={index} className="flex items-start space-x-3 pb-3 border-b border-gray-100 last:border-0">
                    <div className={`w-2 h-2 rounded-full mt-2 flex-shrink-0 ${item.tipo === 'warning' ? 'bg-amber-500' : 'bg-blue-500'}`}></div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm text-gray-900">{item.acao}</p>
                      <div className="flex items-center space-x-2 mt-1">
                        <p className="text-xs text-gray-500">{item.usuario}</p>
                        <span className="text-xs text-gray-400">•</span>
                        <p className="text-xs text-gray-500">{item.data}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal de Confirmação */}
      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4">
              {acaoSelecionada === 'aprovar' && 'Aprovar Venda'}
              {acaoSelecionada === 'reprovar' && 'Reprovar Venda'}
              {acaoSelecionada === 'solicitar' && 'Solicitar Complemento'}
              {acaoSelecionada === 'escalar' && 'Escalar para Supervisor'}
            </h3>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Motivo da decisão <span className="text-red-500">*</span>
              </label>
              <textarea
                value={motivo}
                onChange={(e) => setMotivo(e.target.value)}
                rows={4}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Descreva o motivo da sua decisão..."
              />
            </div>
            <div className="flex items-center space-x-3">
              <button
                onClick={() => {
                  setShowModal(false);
                  setMotivo('');
                }}
                className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                Cancelar
              </button>
              <button
                onClick={confirmarAcao}
                disabled={!motivo.trim()}
                className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}
